/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule';
import { Pagination } from '../models/Pagination';

export class ListObjectStoreExclusionRulesResponse {
  'rules': Array<ObjectStoreExclusionRule>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "rules",
      "baseName": "rules",
      "type": "Array<ObjectStoreExclusionRule>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListObjectStoreExclusionRulesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

